import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ContentLayout from '@layouts/ContentLayout';
import OrderDetailsCard from '@components/OrderDetailsCard';
import { Box } from '@chakra-ui/react';

const OrderDetails = () => {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const orderResource = searchParams.get('orderResource');

  return (
    <ContentLayout>
      <Box pt={4} pl={4} w={'100%'}>
        <OrderDetailsCard
          orderId={orderId}
          orderResource={orderResource}
          showNavLink={true}
        ></OrderDetailsCard>
      </Box>
    </ContentLayout>
  );
};

export default OrderDetails;
